import { render, staticRenderFns } from "./UAMUser.vue?vue&type=template&id=d5660e7a"
import script from "./UAMUser.vue?vue&type=script&lang=js"
export * from "./UAMUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports